import script from "./DoujinCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoujinCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__